import { PERMISSION_CODES } from "@azm/shared/enums/permissions";

export const MOCK_PERMISSIONS: string[] = [
	PERMISSION_CODES.DASHBOARD_CAN_VIEW,
	PERMISSION_CODES.PROFILE_CAN_VIEW,
	PERMISSION_CODES.PROFILE_CAN_EDIT,
	PERMISSION_CODES.LAWSUITS_CAN_VIEW,
	PERMISSION_CODES.LAWSUITS_CAN_VIEW_DETAILS,
	PERMISSION_CODES.LAWSUITS_CAN_VIEW_SAVED,
	PERMISSION_CODES.LAWSUITS_CAN_VIEW_ASSIGNED,
	PERMISSION_CODES.LAWSUITS_CAN_VIEW_AUDIT_LOG,
	PERMISSION_CODES.NOTES_CAN_VIEW,
	PERMISSION_CODES.NOTES_CAN_VIEW_DETAILS,
	PERMISSION_CODES.NOTES_CAN_VIEW_SAVED,
	PERMISSION_CODES.NOTES_CAN_VIEW_ASSIGNED,
	PERMISSION_CODES.NOTES_CAN_VIEW_AUDIT_LOG,
	PERMISSION_CODES.PM_CAN_VIEW,
	PERMISSION_CODES.PM_CAN_VIEW_DETAILS,
	PERMISSION_CODES.PM_CAN_VIEW_SAVED,
	PERMISSION_CODES.PM_CAN_VIEW_ASSIGNED,
	PERMISSION_CODES.PM_CAN_VIEW_AUDIT_LOG,
];
